<template>
  <div class="mt-4">
    <div class="ibox">
      <div class="ibox-title">
        Histórico de consultas desta taxa
      </div>
      <FeeHistories v-if="showFeeHistories" :fee="fee"/>
    </div>
    <div class="ibox">
      <div class="ibox-title">
        Arquivos disponíveis
      </div>
      <div v-if="hasDocuments" class="ibox-content col-md-12">
        <table class="table table-borderless table-border table-align">
          <thead>
          <tr>
            <th>Tipo de documento</th>
            <th>Nome do documento</th>
            <th>Atualizado em</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="document in documents" :key="document.id">
            <td>{{ document.kind | capitalize }}</td>
            <td>{{ filename(document.filename) }}</td>
            <td>{{ document.createdAt | datetime }}</td>
            <td>
              <button v-if="$canDownload('cm-taxas', 'download_docs')" class="btn btn-outline" @click="download(document)">Download</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="ibox-content col-md-12">
        <div class="text-center">
          Nenhum documento disponível no momento
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import FeeHistories from '@/components/cm-taxas/FeesHistory.vue'
  import { mapMutations } from 'vuex'

  export default {
    components: { FeeHistories },
    computed: {
      documents() {
        const documents = this.fee.documents
        documents.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))

        return documents
      },
      hasDocuments() {
        return this.fee.documents && this.fee.documents.length > 0
      },
      fee() {
        return this.getModel
      },
    },
    created() {
      this.asyncTemplateShow(this.id, {
        after: ({model}) => {
          this.setNameBreadcrumb(`${this.filename(model.kind)} - ${model.year}`)
          this.showFeeHistories = true
        },
      })
    },
    data: () => ({
      modelPathPrefix: 'maestro',
      nameModel: 'Fee',
      showFeeHistories: false,
    }),
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
      download(document) {
        this.openLoad()
        this.axios.get(`/maestro/documents/${document.id}/link`)
          .then(response => this.$parse.downloadByLink(response.data))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      filename(name) {
        if (name.includes('others'))
          name = name.replace('others', 'Outros')
        else if (name.includes('ipva'))
          name = name.replace('ipva', 'IPVA')
        else if (name.includes('licenciamento'))
          name = name.replace('licenciamento', 'Licenciamento')

        name = name.replace(/_/g, ' ')
        return name
      }
    },
    mixins: [ModelMapper],
    name: 'Show',
    props: {
      id: { required: false }
    }
  }
</script>

<style scoped>

</style>
